export default {"src":"/_next/static/media/sports6.b6ebf9bb.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};